(function (window, $) {
    'use strict';

    if (!window || !$) {
        console.error('skuQueryService dependencies not loaded.');
        return;
    }

    if (window.skuQueryService) {
        console.warn('skuQueryService already loaded.');
        return;
    }

    var skuQueryService = {
        query: query
    };

    window.tbg = window.tbg || {};
    window.tbg.skuQueryService = skuQueryService;

    return;

    function query (q, successCb, errorCb, completeCb) {
        var numResults = 100;
        var term = encodeURIComponent(q);

        return $.ajax({
            url: '/rest/internal/v1/storefront/sku/search?searchMode=ANY&description=' + term + '&customerSku=' + term + '&numResults=' + numResults,
            method: 'GET',
            contentType: 'application/json',
            success: successCb || noop,
            error: errorCb || noop,
            complete: completeCb || noop
        });

        function noop () { /* noop */ }
    }
}(window, window.jQuery));
